module.exports = __webpack_public_path__ + "static/media/Avatar.e147decf.jpg";